<template>
  <div>
    <header class="top-0 text-second w-full fixed h-14 px-3 flex justify-between rounded-b-lg shadow bg-white place-items-center">
      <button class="h-8" @click="$router.go(-1)">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
      </button>

      <span style="-webkit-line-clamp: 1; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden;" class="text-xl font-extrabold">{{ itemName }}</span>

      <div class="w-8"></div>
    </header>

    <div class="pt-16 px-6 min-h-screen">
      <div>
        <img class="rounded-3xl w-full h-auto object-contain" v-if="item.image" :src="`/media/image/${this.item.image}?size=lg`">
        <img class="rounded-3xl w-full h-auto object-cover" v-else src="@/assets/no-image.jpg"/>
      </div>

      <div class="mt-3 font-bold text-xl">
        {{ itemName }}
      </div>

      <div class="text-xs mt-4 overflow-hidden font-semibold">
        {{ item.description == '' || item.description == undefined ? "Без описания" : item.description }}
      </div>

      <div class="text-xs mt-4 overflow-hidden font-semibold">
        {{ item.volumes == '' || item.volumes == undefined ? "Пицевая ценность не задана" : `Пищеваня ценность в ${item.volumes}` }}
        <br>
        {{ item.energy == undefined ? 'Энергетическая ценность не задана' : `${item.energy} ккал` }}
        <br>
        <br>
        Б - {{ item.proteins == undefined ? 'Не задано' : `${item.proteins} г` }} | Ж - {{ item.fats == undefined ? 'Не задано' : `${item.fats} г` }} | У - {{ item.carbohydrates == undefined ? 'Не задано' : `${item.carbohydrates} г` }}
      </div>
      <div class="h-12"></div>
    </div>
    <button class="rounded-t-lg w-full absolute bg-accent text-white text-xl py-4 bottom-0" @click="add()">
      <div class="flex">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="flex-1 w-8 h-8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
        </svg>
        
        <span class="flex-1">
          Добавить
        </span>

        <span class="flex-1">
          {{ item.price }} ₽
        </span>
      </div>
    </button>
  </div>
</template>

<script>

export default {
  props: ['id'],

  computed: {
    quantity() {
			try {
				return this.$store.getters.basket[this.item.id].quantity
			} catch {
				return 0
			}
		},
    item() {
      return this.$store.getters.menuItemsMap[this.id]
    },
    itemName() {
      return this.item.alt_name == '' || this.item.alt_name == undefined ? this.item.name : this.item.alt_name
    }
  },

  methods: {
    add() {
      if (this.quantity > 0) {
        this.$store.dispatch('increaseItemInBasket', this.item.id)
      } else {
        this.$store.dispatch('addItemInBasket', this.item)
      }
			this.changeTgBtn()
      this.closeBottomSheet()
		},
    changeTgBtn() {
			const basketItems = Object.values(this.$store.getters.basket)
			if (basketItems.length > 0) {
        window.WebApp.enableClosingConfirmation()
        this.$store.commit('mb_setText', `Мой заказ ${basketItems.reduce(
					(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				)} ₽`)
        this.$store.commit('mb_show')

				// window.Telegram.WebApp.isClosingConfirmationEnabled = true
				// window.Telegram.WebApp.MainButton.text = `Мой заказ ${basketItems.reduce(
				// 	(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
				// )} ₽`
				// window.Telegram.WebApp.MainButton.show()
			} else {
        window.WebApp.disableClosingConfirmation()
        this.$store.commit('mb_hide')

				// window.Telegram.WebApp.isClosingConfirmationEnabled = false
				// window.Telegram.WebApp.MainButton.hide()
			}
		}
  }
}
</script>
